import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Header />

      <main>
        <HeroSection />
        <AppSection />
        <IndexSection />
        <CarouselSection />
        <CommentsSection />
        <AboutSection />
        <FaqSection />
        <UpdatesSection />
        <TopicsSection />
        <ContactSection />
        <RankingSection />
        <CardsSection />
        <MediaSection />
        <FeaturesSection />
      </main>

      <Footer />
    </div>
  );
}